"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("@fluentui/react");
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// These values should correspond with what is accepted by the backend
var minLength = 10;
var maxLength = 250;
var ownersDescription = t("repositoryOwnerPanel.assign.repositoryOwner.ownersDescription");
var OwnerPicker = function OwnerPicker(props) {
  var _defaultArtifactOwner;
  var defaultArtifactOwnership = props.defaultArtifactOwnership,
    disabled = props.disabled,
    showError = props.showError,
    onChange = props.onChange;
  var _React$useState = React.useState(""),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    ownerError = _React$useState2[0],
    setOwnerError = _React$useState2[1];
  var _React$useState3 = React.useState(""),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    owners = _React$useState4[0],
    setOwners = _React$useState4[1];
  var _React$useState5 = React.useState(""),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    justification = _React$useState6[0],
    setJustification = _React$useState6[1];
  var showWarningForRemovingAssignment = (defaultArtifactOwnership === null || defaultArtifactOwnership === void 0 ? void 0 : (_defaultArtifactOwner = defaultArtifactOwnership.owners) === null || _defaultArtifactOwner === void 0 ? void 0 : _defaultArtifactOwner.length) > 0 && owners === "";
  React.useEffect(function () {
    var _defaultArtifactOwner2;
    if ((defaultArtifactOwnership === null || defaultArtifactOwnership === void 0 ? void 0 : (_defaultArtifactOwner2 = defaultArtifactOwnership.owners) === null || _defaultArtifactOwner2 === void 0 ? void 0 : _defaultArtifactOwner2.length) > 0) {
      var _defaultArtifactOwner3;
      setOwners(defaultArtifactOwnership === null || defaultArtifactOwnership === void 0 ? void 0 : (_defaultArtifactOwner3 = defaultArtifactOwnership.owners) === null || _defaultArtifactOwner3 === void 0 ? void 0 : _defaultArtifactOwner3.join(", "));
      setJustification(defaultArtifactOwnership.justification);
    }
  }, [defaultArtifactOwnership]);
  var parseOwners = React.useCallback(function (rawOwners) {
    var parsedOwners = rawOwners.split(",").map(function (o) {
      return o.trim().toLocaleLowerCase();
    });
    if (parsedOwners.length !== 2) {
      setOwnerError(ownersDescription);
      return null;
    }
    setOwnerError("");
    return parsedOwners;
  }, []);
  var parseJustification = React.useCallback(function (rawJustification) {
    if (rawJustification.length >= minLength && rawJustification.length <= maxLength) {
      return rawJustification;
    } else {
      return null;
    }
  }, []);
  React.useEffect(function () {
    var parsedOwners = parseOwners(owners);
    var parsedJustification = parseJustification(justification);
    if (parsedOwners === null && showWarningForRemovingAssignment) {
      setOwnerError("");
      onChange({
        justification: "",
        owners: []
      }, true);
      return;
    }
    if (parsedOwners === null || parsedJustification === null) {
      onChange(null, false);
      return;
    }
    onChange({
      justification: parsedJustification,
      owners: parsedOwners
    }, true);
  }, [justification, onChange, owners, parseJustification, parseOwners, showWarningForRemovingAssignment]);
  var ownerField = null;
  var showOwnerError = showError && ownerError;
  var showJustificationError = showError && (justification.length < minLength || justification.length > maxLength);
  var justificationText = "".concat(justification.length, "/").concat(maxLength, " ").concat(t("repositoryOwnerPanel.assign.repositoryOwner.justificationDescription.1"), " ").concat(minLength, " ").concat(t("repositoryOwnerPanel.assign.repositoryOwner.justificationDescription.2"));
  return /*#__PURE__*/React.createElement(_react.Stack, {
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React.createElement(_react.TextField, {
    description: showOwnerError || showWarningForRemovingAssignment ? "" : ownersDescription,
    disabled: disabled,
    errorMessage: showOwnerError ? ownerError : "",
    id: "direct-owner-picker",
    multiple: true,
    onChange: function onChange(_, newValue) {
      setOwners(newValue !== null && newValue !== void 0 ? newValue : "");
    },
    componentRef: function componentRef(textField) {
      return ownerField = textField;
    },
    placeholder: t("repositoryOwnerPanel.assign.repositoryOwner.ownersPlaceholder"),
    type: "email",
    value: owners,
    styles: disabled ? {} : {
      suffix: {
        background: "white"
      }
    },
    onRenderSuffix: function onRenderSuffix() {
      return disabled ? null : /*#__PURE__*/React.createElement(_react.IconButton, {
        "aria-label": t("repositoryOwnerPanel.assign.repositoryOwner.clear"),
        id: "repository-owner-panel-clear-owners-button",
        styles: {
          "root": {
            "border-top": "1px solid black",
            "border-bottom": "1px solid black",
            "border-radius": "0px"
          }
        },
        iconProps: {
          iconName: 'Cancel',
          styles: {
            "root": {
              "fontSize": "12px"
            }
          }
        },
        onClick: function onClick() {
          var _ownerField;
          (_ownerField = ownerField) === null || _ownerField === void 0 ? void 0 : _ownerField.focus();
          setOwners("");
        }
      });
    }
  }), showWarningForRemovingAssignment ? /*#__PURE__*/React.createElement(_react.MessageBar, {
    messageBarType: _react.MessageBarType.warning,
    messageBarIconProps: {
      iconName: "warning"
    }
  }, t("repositoryOwnerPanel.warning.clearOwnership")) : /*#__PURE__*/React.createElement(_react.TextField, {
    description: showJustificationError ? "" : justificationText,
    disabled: disabled,
    errorMessage: showJustificationError ? justificationText : "",
    id: "owners-justification",
    label: t("repositoryOwnerPanel.assign.repositoryOwner.justificationLabel"),
    multiline: true,
    onChange: function onChange(_, newValue) {
      setJustification(newValue !== null && newValue !== void 0 ? newValue : "");
    },
    placeholder: t("repositoryOwnerPanel.assign.repositoryOwner.justificationPlaceholder"),
    resizable: false,
    rows: 4,
    styles: {
      root: {
        fontWeight: "normal"
      }
    },
    value: justification
  }));
};
var _default = OwnerPicker;
exports.default = _default;